module.exports = __webpack_public_path__ + "static/media/confirm-result-herdy-group-2.707c4bae.svg";